import { hasPurchasedTraining as hasPurchasedTrainingService } from '@/gql/services/trainingService';

let hasPurchased: Boolean;

const hasPurchasedTraining = async (
  companyId: String,
  force = false
): Promise<Boolean> => {
  if (hasPurchased && !force) {
    return true;
  }

  hasPurchased = await hasPurchasedTrainingService(companyId);

  return hasPurchased;
};

export default hasPurchasedTraining;
